export const CardAnimation = ({ className }: { className?: string }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    height={395}
    viewBox="0 0 526 395"
    width={526}
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>{`
      @keyframes kf_Ellipse_92_transform_0 {
        0% { animation-timing-function: ease-out; transform: translate(394.198px, 146.849px) rotate(0.929rad) translate(3.291px, -161.684px) rotate(0.668rad); }
        24.87% { transform: translate(385.55px, 251.936px) rotate(0.929rad) translate(3.291px, -161.684px) rotate(0.668rad); }
        25% { transform: translate(386.004px, 252.154px) rotate(0.929rad) translate(3.291px, -161.684px) rotate(0.668rad); }
        50.05% { animation-timing-function: ease-out; transform: translate(263.238px, 274.839px) rotate(0.929rad) translate(3.291px, -161.684px) rotate(0.668rad); }
        74.97% { animation-timing-function: ease-out; transform: translate(211.159px, 188.684px) rotate(0.929rad) translate(3.291px, -161.684px) rotate(0.668rad); }
        100% { transform: translate(394.239px, 147.839px) rotate(0.929rad) translate(3.291px, -161.684px) rotate(0.668rad); }
      }
      #Ellipse_92 { transform-origin: 0 0; animation: kf_Ellipse_92_transform_0 6s linear infinite; }
      @keyframes kf_Ellipse_95_transform_0 {
        0% { animation-timing-function: ease-out; transform: translate(124.694px, 147.807px); }
        24.87% { animation-timing-function: ease-out; transform: translate(54.694px, 65px); }
        49.98% { animation-timing-function: ease-out; transform: translate(-8.306px, 69px); }
        74.97% { animation-timing-function: ease-out; transform: translate(-3.226px, 135.256px); }
        100% { transform: translate(124.694px, 148px); }
      }
      #Ellipse_95 { transform-origin: 0 0; animation: kf_Ellipse_95_transform_0 6s linear infinite; }
      @keyframes kf_Ellipse_96_transform_0 {
        0% { animation-timing-function: ease-out; transform: translate(75.694px, 27px); }
        24.87% { transform: translate(182.308px, 49.903px); }
        49.87% { transform: translate(294.357px, 83.765px); }
        74.96% { animation-timing-function: ease-out; transform: translate(321.769px, 198px); }
        74.97% { animation-timing-function: ease-out; transform: translate(321.396px, 198px); }
        100% { transform: translate(75.694px, 27px); }
      }
      #Ellipse_96 { transform-origin: 0 0; animation: kf_Ellipse_96_transform_0 6s linear infinite; }
    `}</style>
    <g clipPath="url(#clip0_92514_15541)">
      <ellipse
        cx="97.5386"
        cy="128.992"
        fill="url(#paint0_radial_92514_15541)"
        id="Ellipse_92"
        rx="97.5386"
        ry="128.992"
      />
      <ellipse
        cx="198"
        cy="124"
        fill="url(#paint1_radial_92514_15541)"
        fillOpacity="0.5"
        id="Ellipse_95"
        rx="198"
        ry="124"
      />
      <ellipse
        cx="96.5"
        cy="90.5"
        fill="url(#paint2_radial_92514_15541)"
        id="Ellipse_96"
        rx="96.5"
        ry="90.5"
      />
    </g>
    <defs>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(97.5386 128.992) rotate(90) scale(128.992 97.5386)"
        gradientUnits="userSpaceOnUse"
        id="paint0_radial_92514_15541"
        r="1"
      >
        <stop stopColor="#F0D96B" stopOpacity="0.5" />
        <stop offset="1" stopColor="#F0D96B" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(198 124) rotate(90) scale(124 198)"
        gradientUnits="userSpaceOnUse"
        id="paint1_radial_92514_15541"
        r="1"
      >
        <stop stopColor="#EA5B0C" stopOpacity="0.5" />
        <stop offset="1" stopColor="#EA5B0C" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(96.5 90.5) rotate(90) scale(90.5 96.5)"
        gradientUnits="userSpaceOnUse"
        id="paint2_radial_92514_15541"
        r="1"
      >
        <stop stopColor="#EA5B0C" stopOpacity="0.5" />
        <stop offset="1" stopColor="#EA5B0C" stopOpacity="0" />
      </radialGradient>
      <clipPath id="clip0_92514_15541">
        <rect fill="white" height="395" width="526" />
      </clipPath>
    </defs>
  </svg>
);
